<div class="feedback-slides owl-carousel owl-theme">
    <div class="single-feedback-item">
        <p>«Буюрса сиздердин жардамыңыздар менен эң жакшы балл аламын деген ойдомун! ».</p>

        <div class="info">
            <h3>tansu1uu</h3>
            <span>instagram</span>
            <img src="assets/img/feedback/tansu1uu.png" class="shadow rounded-circle" alt="image">
        </div>
    </div>

    <div class="single-feedback-item">
      <p> «Я училась у вас и очень рада этому за два месяца вы помогли мне подготовиться к ОРТ, с помощью вас я получила неплохой балл ». </p>
        <div class="info">
            <h3>2001.t.s</h3>
            <span>instagram</span>
            <img src="assets/img/feedback/2001.png" class="shadow rounded-circle" alt="image">
        </div>
    </div>

    <div class="single-feedback-item">
      <p> «Благодаря вам ученики получают образование, улучшают свои способности, навыки, логику. Благодаря вам столько выпускников получили золотой сертификат. Спасибо за всё ». </p>
        <div class="info">
            <h3>zarina_off_</h3>
            <span>instagram</span>
            <img src="assets/img/feedback/zarina_off_.png" class="shadow rounded-circle" alt="image">
        </div>
    </div>
</div>
